export function ErrorIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <title>Error</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.33 10C18.33 14.6 14.6 18.33 10 18.33C5.4 18.33 1.67 14.6 1.67 10C1.67 5.4 5.4 1.67 10 1.67C14.6 1.67 18.33 5.4 18.33 10Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 14.17C10.46 14.17 10.83 13.79 10.83 13.33C10.83 12.87 10.46 12.5 10 12.5H10C9.54 12.5 9.17 12.87 9.17 13.33C9.17 13.79 9.54 14.17 10 14.17H10ZM9.17 10C9.17 10.46 9.55 10.83 10 10.83C10.46 10.83 10.83 10.46 10.83 10L10.83 6.67C10.83 6.21 10.46 5.83 10 5.83C9.55 5.83 9.17 6.21 9.17 6.67L9.17 10Z"
        fill="white"
      />
    </svg>
  );
}
